<template>
    <div class="cause-share-popup fixed h-screen top-0 left-0 right-0 bottom-0 z-20 overflow-y-auto">
        <div class="cause-single-share flex min-h-screen flex-col bg-white relative">
            <div class="grid-cols-1 mb-12">
                <div class="relative">
                    <button type="button" class="absolute cause-singl-share-back  btn-empty-wrapper close-btn"
                        @click="clickHandler">
                        <svg height="30px" width="30px" style="enable-background:new 0 0 24 24; fill: #fff;"
                            version="1.1" viewBox="0 0 24 24" xml:space="preserve" xmlns="http://www.w3.org/2000/svg"
                            xmlns:xlink="http://www.w3.org/1999/xlink">
                            <g id="grid_system" />
                            <g id="_icons">
                                <path
                                    d="M5.3,18.7C5.5,18.9,5.7,19,6,19s0.5-0.1,0.7-0.3l5.3-5.3l5.3,5.3c0.2,0.2,0.5,0.3,0.7,0.3s0.5-0.1,0.7-0.3   c0.4-0.4,0.4-1,0-1.4L13.4,12l5.3-5.3c0.4-0.4,0.4-1,0-1.4s-1-0.4-1.4,0L12,10.6L6.7,5.3c-0.4-0.4-1-0.4-1.4,0s-0.4,1,0,1.4   l5.3,5.3l-5.3,5.3C4.9,17.7,4.9,18.3,5.3,18.7z" />
                            </g>
                        </svg>
                        <!-- <Close icon="close" color-class="text-text"></Close> -->
                    </button>
                </div>
            </div>
            <h2 class="text-28 font-bold tracking-tight mb-7">
                <span class="text-primary">{{ $t("Tell") }}</span>
                {{ $t("Your Friends") }}<br />{{ $t("and Family About it") }}
            </h2>
            <div class="cause-item__feature cursor-pointer" v-if="cause.logo">
                <img loading="lazy" :src="cause.logo" :alt="cause.title || $t('Cause')" />
            </div>
            <div class="cause-item__body flex-grow">
                <div class="cause-item__content full-content" v-if="cause.desc">
                    {{ cause.desc }}
                </div>
            </div>
            <ul class="share-block flex">
                <li class="share-block__item flex justify-center items-center mr-4">
                    <ShareNetwork network="facebook" :url="$getState('appUrl')" :title="cause.title"
                        :description="cause.desc" :quote="cause.title" @open="openShare">
                        <FacebookIcon />
                    </ShareNetwork>
                </li>
                <li class="share-block__item flex justify-center items-center mr-4">
                    <ShareNetwork network="twitter" :url="$getState('appUrl')" :title="cause.title" @open="openShare">
                        <TwitterIcon />
                    </ShareNetwork>
                </li>
                <li class="share-block__item flex justify-center items-center">
                    <button type="button" class="btn-link" @click="showModal = true">
                        <MessageIcon />
                    </button>
                </li>
            </ul>
        </div>
        <Modal v-if="showModal" :id="cause.id" :title="cause.title" :url="$getState('appUrl')" @close="
    () => {
        showModal = false;
    }
        " />
    </div>
</template>

<script>
import mixins from "../../config/mixins";
import Close from "../UI/Close";
import FacebookIcon from "../Icons/FacebookIcon";
import TwitterIcon from "../Icons/TwitterIcon";
import MessageIcon from "../Icons/MessageIcon";
import Modal from "../Modal/Modal";
export default {
    name: "CauseSingleShare",

    mixins: [mixins.npos],

    components: {
        Modal,
        MessageIcon,
        TwitterIcon,
        FacebookIcon,
        Close
    },

    props: ["cause", "clickHandler"],

    data: function () {
        return {
            fullContent: true,
            showModal: false
        };
    },

    mounted() {
        this.$scrollToTop();
    },

    methods: {
        openShare: function () {
            this.$http.post("user/share_item", {
                item_id: this.cause.id
            });
        }
    }
};
</script>
